import React, { useState } from 'react';
import { Button, Icon, Tooltip } from '@wfp/ui';

import { WarningEvent, WarningEventStatus } from '../../../restapi/types';
import { EditComment } from './EditComment';
import {
	CommentsStatus,
	commentsStatusBtnClass,
	commentsStatusColor,
	commentsStatusIcon,
	commentsStatusLabel,
} from './types';
import { userCanComment } from '../../../restapi/warningEvent';
import { useEWUser } from '../../../hooks/home';

import "./CommentsMark.scss";


interface Props {
	event: WarningEvent;
	active?: boolean;
}

export function CommentsMark({event, active}: Props) {
	const user = useEWUser();

	const [modalOpen, setModalOpen] = useState(false);

	if (!user) {
		return null;
	}

	const status = !event.comment ? CommentsStatus.none :
		(event.comment.isOpen ? CommentsStatus.open : CommentsStatus.done);

	const approved = event.status === WarningEventStatus.approved;
	const canComment = active && !approved && userCanComment(user);

	return <div className="approved-mark">
		<Tooltip dark trigger="hover" placement="top"
				 createRefWrapper={true}
				 content={<div>
					 <p className="no-wrap">{commentsStatusLabel[status]}</p>
					 {canComment && <p className="no-wrap">Click to {!event.comment ? 'add' : 'edit'}</p>}
				 </div>}>
			{canComment ?
				<Button className={commentsStatusBtnClass[status]}
						icon={commentsStatusIcon[status]} iconDescription=" " small kind="ghost"
						onClick={() => setModalOpen(true)}/>
				: <Icon fill={commentsStatusColor[status]}
						icon={commentsStatusIcon[status]}
						description=""/>
			}
		</Tooltip>
		{modalOpen &&
			<EditComment event={event}
						 onClose={() => setModalOpen(false)}
			/>}
	</div>;

}